<template>
  <profile-main>
    <profile-header activeMenu="setting" slot="profileNavigation" />
    <loading-container :loading="false">
      <div class="card">
        <h5 class="card-title">Setting</h5>
        <div class="d-flex no-block align-items-start m-t-20 m-b-20">
          This feature is coming...
        </div>
      </div>
    </loading-container>
  </profile-main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import InputText from '@/components/Form/InputText';
import RadioButton from '@/components/Form/RadioButton';
import FormButton from '@/components/Form/FormButton';
import LinkButton from '@/components/Misc/LinkButton';
import LoadingContainer from '@/components/Misc/LoadingContainer';
import ProfileHeader from './components/Header';
import ProfileMain from './components/Main';

export default {
  name: 'Setting',
  components: {
    InputText,
    RadioButton,
    FormButton,
    LinkButton,
    LoadingContainer,
    ProfileHeader,
    ProfileMain,
  },
  beforeMount() {
    this.getUserInfo();
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      form: 'auth/form',
    }),

    currentUser() {
      return this.user || {};
    },
    currentRole() {
      return this.currentUser.role;
    },
  },
  methods: {
    ...mapActions({
      setField: 'auth/setField',
      getUserInfo: 'auth/getUserInfo',
    }),
  },
};
</script>
